import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { handleActions } from 'redux-actions';
import { upsertResources, completeWithError, upsertResource, upsertResourceSetupUndo, resetResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './alertsActions';

const alertsReducer = handleActions({

  [actions.updateAlert]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.updateAlert),
  [actions.updateAlertSuccess]:
    (state, { payload }) => upsertResource(state, payload),

  [actions.updateAlertFailure]:
    (state, { payload: error, asyncDispatch }) => {
      asyncDispatch(actions.getAlerts());
      return resetResources(state, error);
    },

  [actions.getAlerts]:
    (state) => state.merge({ isLoading: true }),
  [actions.getAlertsSuccess]:
    (state, { payload }) => upsertResources(state, payload),
  [actions.getAlertsFailure]:
    (state, { payload: error }) => completeWithError(state, error),

}, mkQcsSyncResourceStore());

export const ALERTS_REDUCER_KEY = 'alertsStore';
export default alertsReducer;
